<template>
  <v-navigation-drawer
    v-model="drawer"
    style="height: 100dvh !important; height: 100vh;"
    fixed
    app
    disable-resize-watcher
    disable-route-watcher
    width="232"
  >
    <v-list
      dense
    >
      <!-- **************************
      ********** TITRE APP **********
      *************************** -->
      <v-list-item
        ripple
        name="drawer"
        @click="drawer = false"
      >
        <img
          :src="AppImages.logo"
          width="24px"
          alt="logo"
        >
        <v-list-item-title class="subheading ml-3">
          {{ appName }}
        </v-list-item-title>
        <v-app-bar-nav-icon /> <!-- => burger icon -->
      </v-list-item>

      <v-divider
        v-show="options.infos > 0 || options.search > 0"
        class="mt-2"
      />

      <!-- ************************
      ********** ACTIONS **********
      ************************* -->
      <template v-if="isAuthenticated">
        <section v-if="!modeSessionFloating">
          <v-list-item
            v-show="options.infos > 0"
            ripple
            name="info-badge"
            :disabled="options.infos === 2"
            @click="infosBadge"
          >
            <v-list-item-action>
              <v-icon>{{ IconEnum.info_badge }}</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_badge_info')" />
          </v-list-item>
          <v-list-item
            v-show="isMarketPlace"
            ripple
            name="info-commande"
            @click="infosCommande"
          >
            <v-list-item-action>
              <v-icon>{{ IconEnum.info_commande }}</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_commande_info')" />
          </v-list-item>
          <v-list-item
            v-show="options.search > 0"
            to="/customer-search"
            ripple
            name="search"
            :disabled="offline || options.search === 2"
          >
            <v-list-item-action>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 1664 1792"
              >
                <path
                  :fill="offline || options.search === 2 ? '#9e9e9e' : '#FFFFFF'"
                  d="M1028 644q0 107-76.5 183T768 903t-183.5-76T508 644q0-108 76.5-184T768 384t183.5 76t76.5 184zm-48 220q46 0 82.5 17t60 47.5t39.5 67t24 81t11.5 82.5t3.5 79q0 67-39.5 118.5T1056 1408H480q-66 0-105.5-51.5T335 1238q0-48 4.5-93.5T358 1046t36.5-91.5t63-64.5t93.5-26h5q7 4 32 19.5t35.5 21t33 17t37 16t35 9T768 951t39.5-4.5t35-9t37-16t33-17t35.5-21t32-19.5zm684-256q0 13-9.5 22.5T1632 640h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v224q0 66-47 113t-113 47H160q-66 0-113-47T0 1632V160Q0 94 47 47T160 0h1216q66 0 113 47t47 113v224h96q13 0 22.5 9.5t9.5 22.5v192zm-256 1024V160q0-13-9.5-22.5T1376 128H160q-13 0-22.5 9.5T128 160v1472q0 13 9.5 22.5t22.5 9.5h1216q13 0 22.5-9.5t9.5-22.5z"
                />
              </svg>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_search')" />
          </v-list-item>
          <v-list-item
            v-if="useGiftReset"
            ripple
            name="gift-reset"
            @click="toReset"
          >
            <v-list-item-action>
              <v-icon>mdi-restart</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_reset')" />
          </v-list-item>
          <v-list-item
            v-if="isRechargementAutorise"
            to="/credit-gift"
            name="credit_carte"
          >
            <v-list-item-action>
              <v-icon>mdi-layers-plus</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_credit_carte')" />
          </v-list-item>
          <v-divider v-show="options.duplicate > 0 || options.cancel > 0" />

          <v-list-item
            v-show="options.duplicate > 0"
            ripple
            name="duplicate"
            :disabled="options.duplicate === 2"
            @click="duplicate"
          >
            <v-list-item-action>
              <v-icon>{{ IconEnum.duplicate }}</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_duplication')" />
          </v-list-item>
          <v-list-item
            v-if="showDuplicateCB"
            ripple
            name="duplicateCB"
            @click="duplicateCB"
          >
            <v-list-item-action>
              <v-icon>{{ IconEnum.duplicate }}</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_duplication_cb')" />
          </v-list-item>
          <v-list-item
            v-show="options.cancel > 0"
            ripple
            name="cancellation"
            :disabled="!paxConnected || options.cancel === 2"
            @click="offline ? cancellation() : showModal('cancellation')"
          >
            <v-list-item-action>
              <v-icon>{{ IconEnum.cancellation }}</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_cancelation')" />
          </v-list-item>

          <v-divider v-show="options.consult > 0 || options.collect > 0" />
          <!-- ***************************
        ********** OPERATIONS **********
        **************************** -->
          <v-list-item
            v-show="options.consult > 0"
            ripple
            name="consultation"
            style="min-height: 48px"
            :disabled="options.consult === 2"
            @click="consultation"
          >
            <img
              :src="AppImages.alphaXBox"
              class="svg"
              width="24"
              height="24"
              alt="alphaXBox"
            >
            <v-list-item-title
              class="ml-3"
              v-text="$t('button.dw_consultation')"
            />
          </v-list-item>
          <v-list-item
            v-show="options.collect > 0"
            ripple
            name="tellecolection"
            style="min-height: 48px"
            :disabled="options.collect === 2"
            @click="showModal('tellecolection')"
          >
            <img
              :src="AppImages.alphaZBox"
              class="svg"
              width="24"
              height="24"
              alt="alphaZBox"
            >
            <v-list-item-title
              class="ml-3"
              v-text="$t('button.dw_telecolection')"
            />
          </v-list-item>

          <v-divider />
          <v-list-item
            v-show="showFinSession"
            ripple
            name="info-commande"
            @click="finSession()"
          >
            <v-list-item-title
              style="display: flex; justify-content: center; align-items: center; color: red; font-size: medium"
              v-text="$t('button.dw_fin_session')"
            />
          </v-list-item>
          <v-divider />
        </section>
      </template>

      <!-- *******************************
      ********** BOTTOM ACTIONS **********
      ******************************** -->
      <div class="pull-bottom bloc">
        <template v-if="isAuthenticated">
          <v-list-item
            ripple
            name="settings"
            class="needsclick"
            @click="action('settings')"
          >
            <v-list-item-action>
              <v-icon size="25">
                {{ IconEnum.settings }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_setting')" />
          </v-list-item>
          <v-list-item
            v-show="shopsLength > 1"
            ripple
            name="shop-choice"
            :disabled="cantDisconnect"
            @click="action('shop')"
          >
            <v-list-item-action>
              <v-icon
                size="25"
                color="orange darken-2"
              >
                {{ IconEnum.shop_choice }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_change_shop')" />
          </v-list-item>
          <v-list-item
            ripple
            name="disconnection"
            :disabled="cantDisconnect"
            @click="showModal('disconnection')"
          >
            <v-list-item-action>
              <v-icon
                medium
                color="red"
                style="margin-left: -1px;"
              >
                {{ IconEnum.disconnection }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="$t('button.dw_disconnection')" />
          </v-list-item>
        </template>
        <v-list-item
          ripple
          name="support"
          @click="action('support')"
        >
          <v-list-item-action>
            <v-icon style="margin-left: 1px;">
              {{ IconEnum.info }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="$t('button.dw_support')" />
        </v-list-item>
        <v-list-item
          v-if="!IS_DESKTOP && !IS_IOS"
          ripple
          name="close_app"
          @click="action('exit')"
        >
          <v-list-item-action>
            <v-icon style="margin-left: 1px;">
              {{ IconEnum.close_app }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="$t('button.dw_close_app')" />
        </v-list-item>
      </div>
    </v-list>

    <ui-dialog
      v-model="dialog.show"
      :title="dialog.title"
      :content="dialog.content"
      :danger="dialog.danger"
      btn-validate="OK"
      btn-cancel="Retour"
      @validate="dialog.action"
      @hide="dialog.show = false"
    />

    <password-dialog
      v-if="usepassword"
      v-model="pwdDialog"
      @valid="validPwd"
      @cancel="pwdDialog = false"
    />

    <support-dialog
      v-model="showSupportDialog"
    />
  </v-navigation-drawer>
</template>

<script>
import {Operations} from '@/modules/Operations'
import {ActionEnum, EnumModeCashiers, IconEnum} from '@/modules/Enums'
import {AppImages} from '@/modules/Images'
import SupportDialog from '@/components/modal/SupportDialog.vue'

import {MetierLocalStorage} from 'modulelocalstorage'
import {name} from '../../../package.json'

import PasswordDialog from '@/components/modal/PasswordDialog'
import {$alert, stopServices} from '@/modules/Utils'
import {neptingRequest} from '@/modules/Banking'

export default {
  name: 'Drawer',

  components: {
    PasswordDialog,
    SupportDialog
  },
  props: {
    showFinSession: {type: Boolean, default: null},
  },
  data() {
    return {
      AppImages,
      IconEnum,
      IS_DESKTOP,
      IS_IOS,
      currentAction: null,
      appName: name,
      //
      pwdDialog: false,
      showSupportDialog: false,
      dialog: {
        show: false,
        title: null,
        content: null,
        danger: false,
        action: () => {
        }
      }
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('drawer', val)
      }
    },
    options() {
      return this.$store.state.drawerOptions
    },
    shopsLength() {
      return this.$store.state.shops.length
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    offline() {
      return this.$store.state.offline
    },
    paxConnected() {
      return this.$store.state.neptingInfos !== null
    },
    usepassword() {
      return this.$store.state.usepassword
    },
    isConnected() {
      return this.$store.getters.isConnected
    },
    cantDisconnect() {
      return this.$store.getters.totalTransactions > 0 || (!IS_DESKTOP && !this.isConnected)
    },
    useGiftReset() {
      return this.$store.getters.useGiftReset
    },
    paymentService() {
      return this.$store.getters.paymentService
    },
    isRechargementAutorise() {
      return this.$store.getters.chequeCreditAccept || this.$store.getters.carteCreditAccept
    },
    isMarketPlace() {
      return this.$store.getters.isMarketPlace
    },
    showDuplicateCB() {
      return this.$store.getters.useBanking
    },
    modeSessionFloating() {
      let teleparameters = this.$store.state.teleparameters;
      let connectedCashier = MetierLocalStorage.getConnectedCashier();

      let mode = teleparameters?.CashierEngagementMode ?? null;
      let cashiers = teleparameters?.Cashiers ?? [];
      return (mode === EnumModeCashiers.SESSION || mode === EnumModeCashiers.FLOATING) && cashiers.length > 0 && !connectedCashier;
    }
  },

  methods: {
    // CALLBACKS
    successcallback(message, type = 'success') {
      $alert(message, type)
    },
    errorcallback(error) {
      $alert(error)
    },
    //
    showModal(action) {
      switch (action) {
        case 'cancellation':
          this.dialog.title = this.$i18n.t('dialog.cancellation_title')
          this.dialog.content = this.$i18n.t('dialog.cancellation_content')
          this.dialog.danger = true
          this.dialog.action = this.cancellation
          break
        case 'tellecolection':
          this.dialog.title = this.$i18n.t('dialog.tellecolection_title')
          this.dialog.content = this.$i18n.t('dialog.tellecolection_content')
          this.dialog.danger = false
          this.dialog.action = this.telecollection
          break
        case 'disconnection':
          this.dialog.title = this.$i18n.t('dialog.disconnection_title')
          this.dialog.content = this.$i18n.t('dialog.disconnection_content')
          this.dialog.danger = true
          this.dialog.action = () => {
            this.action('logout')
          }
          break
      }
      this.dialog.show = true
    },
    // ACTIONS
    infosBadge() {
      this.$emit('title', this.$i18n.t('title.info_badge'))
      this.$router.replace({
        name: this.offline ? 'scan-nfc-offline' : 'action-choice',
        params: {action: ActionEnum.badgeInformations, mode: 'P', backToHome: true}
      })
    },
    infosCommande() {
      this.$emit('title', this.$i18n.t('title.info_commande'))
      this.$router.replace({
        name: 'scan-qrcode',
        params: {action: ActionEnum.commandeInformations, mode: 'P', backToHome: true}
      })
    },
    toReset() {
      this.$router.replace({
        name: 'action-choice',
        params: {action: ActionEnum.giftReset, mode: 'P', backToHome: true}
      })
    },
    cancellation() {
      this.dialog.show = false
      if (this.offline) {
        $alert(this.$i18n.t('info.offline_cancellation'), 'info')
        this.infosBadge()
      } else {
        Operations.cancellation(
          (message, type = 'success') => {
            this.successcallback(message, type);
            this.finSession();
          },
          this.errorcallback
        );
      }
    },
    duplicate() {
      if (this.offline) {
        let ticket = MetierLocalStorage.getTicket()
        if (ticket !== null) {
          this.$router.replace({name: 'ticket', params: {tickets: ticket}})
        } else {
          $alert(this.$i18n.t('error.no_duplicate'))
        }
      } else {
        Operations.duplicate(this.successcallback, this.errorcallback)
      }
    },
    duplicateCB() {
      let tickets = MetierLocalStorage.getTicket()
      if (tickets !== null) {
        this.$router.replace({name: 'ticket', params: {tickets: tickets}})
      } else if (this.paymentService === 'nepting') {
        neptingRequest('ReprintLastTrs')
          .then((tickets) => {
            if (tickets.length > 0) {
              this.$router.replace({name: 'ticket', params: {tickets: tickets}})
            } else {
              $alert(this.$i18n.t('error.no_duplicate'))
            }
          })
      } else if (this.paymentService === 'pax') {
        Pax.paxRequest({action: 'DUPLICATA'})
      } else {
        $alert(this.$i18n.t('error.no_duplicate'))
      }
    },
    // OPERATIONS
    consultation() {
      if (this.offline && this.cantDisconnect) {
        $alert(!this.isConnected ? this.$i18n.t('info.no_internet')
          : this.$i18n.t('info.wait_end_trx'), 'info')
      } else {
        Operations.consultation(this.successcallback, this.errorcallback)
      }
    },
    telecollection() {
      this.dialog.show = false
      if (this.offline && this.cantDisconnect) {
        $alert(!this.isConnected ? this.$i18n.t('info.no_internet')
          : this.$i18n.t('info.wait_end_trx'), 'info')
      } else if (this.paymentService === 'pax') {
        Pax.paxRequest(
          {action: 'TLC'},
          () => {
            Operations.telecollection(this.successcallback, this.errorcallback)
          }
        )
      } else {
        Operations.telecollection(this.successcallback, this.errorcallback)
      }
    },
    // BOTTOM ACTIONS
    action(type, passwordIsValid = false) {
      if (this.usepassword && !passwordIsValid) {
        // Fermeture drawer
        this.drawer = false
        this.$nextTick(_ => {
          this.currentAction = type
          this.pwdDialog = true
        })
      } else {
        if (type === 'settings') {
          this.$router.replace('/settings')
        } else if (type === 'support') {
          this.showSupportDialog = true
        } else if (type === 'exit') {
          if (navigator.app) navigator.app.exitApp()
        } else {
          stopServices()
          if (type === 'shop') {
            this.$store.dispatch('partialClear')
          } else {
            this.$store.dispatch('clear')
            this.dialog.show = false
          }
          this.$router.replace('/')
        }
      }
    },
    validPwd() {
      this.action(this.currentAction, true)
      this.currentAction = null
      this.pwdDialog = false
    },
    finSession() {
      localStorage.removeItem('connectedCashier')
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
.v-avatar {
  margin-left: -5px;
}

.v-list-item__action {
  margin-right: 14px !important;
}
</style>
